// File: WorkOpportunities.jsx

import "./WorkOpportunities.css";

const WorkOpportunities = ({ countryData }) => {
  const work = countryData.workOpportunities || {};
  const { intro = "", options = [], jobs = [], regulations = [] } = work;

  return (
    <div className="work-opportunities-container">
      <h1>Part-time Careers and Work Opportunities in {countryData.name}</h1>

      <p className="work-intro">{intro}</p>

      {/* Options Section */}
      <div className="work-options-grid">
        {options.map((opt, idx) => (
          <div className="work-option-card" key={idx}>
            <h2>{opt.title}</h2>
            <p>{opt.description}</p>
          </div>
        ))}
      </div>

      {/* Jobs Section */}
      <div className="popular-jobs-section">
        <h2>Popular Part-time Jobs for International Students</h2>
        <div className="jobs-grid">
          {jobs.map((job, idx) => (
            <div className="job-card" key={idx}>
              <div className="job-icon">
                {/* placeholder icon */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#9C27B0" strokeWidth="2" />
                </svg>
              </div>
              <h3>{job.title}</h3>
              <p>Average Pay: {job.pay}</p>
              <p>{job.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Regulations Section */}
      <div className="work-regulations-section">
        <h2>Work Regulations for International Students</h2>
        <div className="regulations-grid">
          {regulations.map((rule, idx) => (
            <div className="regulation-card" key={idx}>
              <h3>{rule.title}</h3>
              <ul>
                {rule.points.split(". ").map((point, i) =>
                  point.trim() ? <li key={i}>{point.trim()}</li> : null
                )}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkOpportunities;
